import './FakeTopBar.css';

type FakeTopBarProps = {
  height: number;
};

/**
 * This is created as a fake topbar as the radial gradient is not supported for border
 * in vanilla css yet. So this is on of the accepted workarounds
 */

export const FakeTopBar = ({ height }: FakeTopBarProps) => {
  return <div className="stylishbordertop" style={{ height }}></div>;
};
